module.exports = __webpack_public_path__ + "img/Component13–1(HoverState).b1febad1.png";